import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-791c80f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"right"} }
const _hoisted_2 = { style: {"margin-top":"20px"} }

import { ref, reactive, onMounted, unref } from 'vue';

/* NPM Plugins */
import moment from 'moment';

/* Componetns */
import { GbDialog } from '@/components/GbDialog/Index';
import { GbTables } from '@/components/GbTables';
import DicDetailDialog from './DicDetailDialog.vue'

/* Hooks & Utils */
import { useLocales } from '@/hooks/useLocales';
import { useGbTable } from '@/hooks/useGbTable'

/* Types */
import { TableColumn } from '../../../../components/GbTables/GbTablesTypes';
import { DicListDto, DicListSearch, PubDicDelete } from '../../../../apis/dictionary_pub/pub.dictionary.type';

/* Apis */
import { GetDicListApi, DicDeleteApi } from '../../../../apis/dictionary_pub/pub.dictionary.api';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { t } = useLocales();

const dialogRef = ref<ComponentRef<typeof DicDetailDialog>>()

const show = ref<boolean>(false)

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<DicListDto>({
    getListApi: GetDicListApi,
    delListApi: DicDeleteApi,
    response: { data: 'data', total: 'total' }
})

const { setSearchParams } = methods

const search = reactive<DicListSearch>({ group_id: '', current: 1, page_size: 10 })

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
    { field: 'name', label: t('systems.dictionary.dialog.table.name', '字典名称'), columnWidth: "150" },
    { field: 'dvalue', label: t('systems.dictionary.dialog.table.value', '字典值'), align: "left" },
    { field: 'code', label: t('systems.dictionary.dialog.table.code', '字典标识(可选)'), columnWidth: "150" },
    { field: 'sort', label: t('systems.dictionary.dialog.table.sort', '排序'), columnWidth: "80", align: 'center' },
    { field: 'can_select', label: t('systems.dictionary.dialog.table.canSelect', '列表可选'), columnWidth: "80", align: 'center' },
    { field: 'is_enabled', label: t('systems.dictionary.dialog.table.status', '状态'), columnWidth: "80", align: 'center' },

    // { field: 'created_time', label: '创建时间', columnWidth: "120", fixed: 'right', align: 'center' },
    { field: 'action', width: '120px', label: t('systems.dictionary.dialog.table.actions', '操作'), fixed: 'right', align: 'center' }
])

const actions = {

    createDic: () => {
        const groupId = unref(search).group_id;

        unref(dialogRef)?.showDialog(groupId, false)
    },

    modifyDic: (rowId: string) => {

        unref(dialogRef)?.showDialog(rowId, true)

    },

    /* 删除字典 */
    delterDic: async (row: any) => {
        const delData: PubDicDelete = { id: row.id, revision: row.revision }

        await methods.deleteRows(delData)
    }
}

/* 显示对话框 */
const showDialog = (groupId: string) => {

    unref(search).group_id = groupId;

    setSearchParams(search)

    show.value = true
}

expose({ showDialog })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(GbDialog), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((show).value = $event)),
      title: _unref(t)('systems.dictionary.dialog.title.list', '字典表'),
      style: {"width":"1000px"}
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "info",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (show.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('buttons.closed')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            size: "small",
            type: "info",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('systems.dictionary.dialog.buttons.refresh', '刷新')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (actions.createDic()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('systems.dictionary.dialog.buttons.create', '新建')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(GbTables), {
            pageSize: _unref(tableObject).pageSize,
            "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
            currentPage: _unref(tableObject).currentPage,
            "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
            columns: _unref(tabColumns),
            data: _unref(tableObject).tableList,
            loading: _unref(tableObject).loading,
            pagination: { total: _unref(tableObject).total },
            onRegister: _unref(register)
          }, {
            created_time: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format("YYYY/MM/DD HH:mm")), 1)
            ]),
            is_enabled: _withCtx(({ row }) => [
              (row.is_enabled == 'Y')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    size: "small",
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('systems.dictionary.dialog.options.enabled', '启用')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (row.is_enabled == 'N')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    size: "small",
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('systems.dictionary.dialog.options.disabled', '停用')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            can_select: _withCtx(({ row }) => [
              (row.can_select == 'Y')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    size: "small",
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('systems.dictionary.dialog.options.selectable', '可选')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (row.can_select == 'N')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    size: "small",
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('systems.dictionary.dialog.options.notSelectable', '不可选')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            action: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                link: "",
                onClick: ($event: any) => (actions.modifyDic(row.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('buttons.modify')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                size: "small",
                type: "danger",
                link: "",
                onClick: ($event: any) => (actions.delterDic(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('buttons.delete')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(DicDetailDialog, {
      ref_key: "dialogRef",
      ref: dialogRef,
      onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
    }, null, 512)
  ], 64))
}
}

})